<template>
  <div>
    <b-overlay :show="show" rounded="sm">
      <b-card no-body>
        <div class="m-2">
          <div class="d-flex justify-content-between">
            <div class="flex-grow-1">
              <div class="row">
                <div class="col-md-3">
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-table-simple hover responsive class="rounded-bottom mb-0">
          <b-thead head-variant="light">
            <b-tr>
              <b-th>#</b-th>
              <b-th>URL</b-th>
              <b-th>Description / Purpose</b-th>
              <b-th>Action</b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr v-for="item in zapeData" :key="item._id">
              <b-td>{{ item.sr }}</b-td>
              <b-td>{{ baseUrl + item.url }}</b-td>
              <b-td>{{ item.description }}</b-td>
              <b-td>
                <b-button size="sm" variant="primary" @click="submitAction(item)"  :disabled="item.disabled">
                  Submit
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BOverlay,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    BCard,
    BButton,
    BOverlay,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
  },

  data() {

    return {
      show: false,
      baseUrl: process.env.VUE_APP_ZAPE_WEBSITE_URL,
      zapeData: [
        {
          _id: 1,
          sr: 1,
          url: `/fetch-data-mongodb`,
          description:
            "Fetch the latest classes, subjects, and topics from MongoDB for the Zape website.",
          confirmText:
            "This action will update the data of Zape website",
          disabled: false,
        },
        {
          _id: 2,
          sr: 2,
          url: `/clear-all-caches`,
          description: "Clear all cached data for the Zape website to ensure up-to-date content.",
          confirmText:
            "This action will clear the cache of Zape website",
          disabled: false,

        },
      ],
    };
  },

  methods: {
    submitAction(item) {
      Swal.fire({
        title: "Are you sure?",
        text: item.confirmText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, proceed",
        cancelButtonText: "Cancel",
        buttonsStyling: true,
        customClass: {
          confirmButton: 'swal2-confirm me-2',
          cancelButton: 'swal2-cancel'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.callApi(item);
        }
      });
    },

    async callApi(item) {
      try {
        const fullUrl = this.baseUrl + item.url;
        this.show = true;
        await axios.get(fullUrl);
        this.show = false;
        item.disabled = true; 

        Swal.fire({
          title: "Success",
          text: "The action has been successfully completed!",
          icon: "success",
        });
      } catch (error) {
        this.show = false;
        Swal.fire({
          title: "Error",
          text: "Something went wrong, please try again later!",
          icon: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.add-catrgory-button {
  margin-top: 10px;
}
</style>
<style>
.vs__open-indicator {
  fill: #9d9d9d !important;
}

.swal2-styled {
  margin: .3125em !important;

}
</style>